import { render, staticRenderFns } from "./LocalParameters.vue?vue&type=template&id=0432b581&scoped=true&"
var script = {}
import style0 from "./LocalParameters.vue?vue&type=style&index=0&id=0432b581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0432b581",
  null
  
)

export default component.exports